import React  from 'react'
import DropDown from '../dropdown';
import { GetBanks } from '../../../api/services/finance';

const BanksDropDown = (props) => {
    return <DropDown api={GetBanks} search textField="Name" valueField="Id" descriptionField="Code" {...props} />
}

export default BanksDropDown
